import { Controller } from "@hotwired/stimulus";

// 顧客向けのお知らせのプレビューに使用する機能
// 内部スクロールバーなしで表示させたいので、iframe の高さを中身のコンテンツに合わせて自動調整する。
// iframe タグでは、sandbox="allow-same-origin" の 属性を付与している。
// この属性は、iframe の contentDocument を読むために必要となる。
export class IframeAutoheightController extends Controller {
  connect() {
    this.resize = this.resize.bind(this);
    this.element.addEventListener("load", this.resize);
    window.addEventListener("resize", this.resize);
    this.resize();
  }

  disconnect() {
    this.element.removeEventListener("load", this.resize);
    window.removeEventListener("resize", this.resize);
  }

  resize() {
    try {
      const doc = this.element.contentDocument || this.element.contentWindow?.document;
      if (!doc?.documentElement) return;

      this.element.style.height = `${doc.documentElement.scrollHeight}px`;
    } catch (_e) {
      // cross-origin 等で contentDocument にアクセスできない場合は何もしない
    }
  }
}
